export function isFetchingSchemaInterface(schema) {
    return schema.url !== undefined;
}
export var PayloadType;
(function (PayloadType) {
    PayloadType["PUBLISH"] = "publish";
    PayloadType["SUBSCRIBE"] = "subscribe";
})(PayloadType || (PayloadType = {}));
//# sourceMappingURL=types.js.map